export default __webpack_public_path__ + "static/cosmetic_insurance_3-2e1a6beef5ea0576df92141fa07cae31.webp";